import React from 'react';
import ModuleReservation from '../components/ModuleReservation';

const GaresAeroportsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white py-16 px-4 border-b-4 border-[#e2b13c] overflow-hidden">
        {/* Image de fond - Gare Lille Europe */}
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: 'url(/images/gare-lille-europe.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c] drop-shadow-lg">
            Transferts Gares & Aéroports : Voyagez l'esprit léger
          </h1>
          <h2 className="text-2xl font-semibold mb-8 text-gray-200 drop-shadow-md">
            Navettes vers Lille-Lesquin, Roissy-CDG, Bruxelles-Zaventem, Charleroi
          </h2>
          <div className="text-lg leading-relaxed text-gray-300 max-w-3xl mx-auto bg-black bg-opacity-50 p-6 rounded-lg">
            <p className="mb-4">
              Commencez votre voyage dans les meilleures conditions. Oubliez la fatigue au volant et les parkings hors de prix. Nous suivons l'horaire de votre vol ou de votre train en temps réel.
            </p>
            <p className="font-semibold text-[#e2b13c]">
              En cas d'avance ou de retard, votre chauffeur privé vous attendra à votre arrivée avec une pancarte à votre nom aux Gares Lille Flandres ou Lille Europe.
            </p>
          </div>
        </div>
      </div>

      {/* Liste des destinations */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[#0f172a] p-6 rounded-lg border-2 border-[#e2b13c]">
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">✈️ Aéroports</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Lille-Lesquin</li>
              <li>• Paris CDG (Roissy)</li>
              <li>• Paris Orly</li>
              <li>• Bruxelles-Zaventem</li>
              <li>• Charleroi</li>
              <li>• Beauvais</li>
              <li>• Amsterdam Schiphol</li>
            </ul>
          </div>
          <div className="bg-[#0f172a] p-6 rounded-lg border-2 border-[#e2b13c]">
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">🚆 Gares</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Lille Flandres</li>
              <li>• Lille Europe</li>
              <li>• Paris Gare du Nord</li>
              <li>• Bruxelles Midi</li>
              <li>• Toutes gares SNCF régionales</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Module de Réservation (MÊME QUE PAGE D'ACCUEIL) */}
      <div className="py-16 px-4">
        <ModuleReservation />
      </div>
    </div>
  );
};

export default GaresAeroportsPage;